import {
  CommitmentsSection,
  CommitmentsBox,
  CommitmentsCard,
} from "./style";

import TitleComponent from "../SectionTitle"
import CommitmentsCarousel from "../CommitmentsCarousel";

const CommitmentsComponent = () => {

  return (
    <CommitmentsSection id="Nossos-Compromissos">
      <TitleComponent TitleText={'Entenda'} SubTitleText={'Nossos compromissos'} />
      <CommitmentsBox>
        <CommitmentsCard>
          <strong>2024</strong>
          <ul>
            <li>100% Cadeia de Fornecedores diretos de produto acabado e seus subcontratados Certificados em aspectos socioambientais.​</li>
          </ul>
        </CommitmentsCard>
        <CommitmentsCard>
          <strong>2030</strong>
          <ul>
            <li>100% da cadeia de fornecedores de produto acabado rastreada.</li>
            <li>100% do couro de todos os produtos rastreados até as fazendas de cria e/ou recria.</li>
            <li>60% de materiais sustentáveis em todos os produtos.</li>
            <li>100% das embalagens feitas com materiais sustentáveis.</li>
            <li>Implantação de logística reversa em 100% das lojas próprias e franquias nacionais.</li>
            <li>Redução de 30% das emissões escopo 1,2,3.</li>
            <li>25% de pessoas negras em cargos de liderança.</li>
            <li>100% de transparência para o consumidor sobre composição, fabricação e origem.</li>
            <li>Estar posicionada entre as top 10 empresas de varejo no Brasil no ISE B3.</li>
            <li>Obter nota superior a 70% no índice de Transparência da Moda em marcas respondentes.</li>
          </ul>
        </CommitmentsCard>
        <CommitmentsCard>
          <strong>2050</strong>
          <ul>
            <li>100% do algodão de todos os produtos rastreado até a plantação</li>
            <li>Net zero.</li>
          </ul>


        </CommitmentsCard>
      </CommitmentsBox>
      {/* <CommitmentsCarousel /> */}
    </CommitmentsSection>
  );
};

export default CommitmentsComponent;
